import {Component, Input, OnInit} from '@angular/core';
import {WdrCosmoBericht} from "../../../../../../../model/vorhersagen/wdr-wetterbericht";

@Component({
  selector: 'app-wdr-cosmo-bericht',
  templateUrl: './wdr-cosmo-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrCosmoBerichtComponent {
  @Input() cosmoBericht: WdrCosmoBericht;


}
